import { useContext } from 'react';

import { PaymentContextType } from './types';

import PaymentContext from './context';

const usePaymentContext = () => useContext<PaymentContextType>(PaymentContext);

export default usePaymentContext;
